export default {
  error: {
    DEFAULT: {
      title: 'Erreur',
      text: 'Une erreur s\'est produite, veuillez réessayer ultérieurement ou nous contacter au 01.82.52.10.12 si le problème persiste',
    },
    LOGIN: {
      title: 'Erreur d\'authentification',
      text: 'On dirait que vous avez entré un identifiant/mot de passe erroné... Essayez de nouveau !',
    },
    NOT_LOGGED: {
      title: 'Erreur d\'authentification',
      text: 'Vous êtes déconnecté, veuillez vous reconnecter avec votre mot de passe ou via le lien reçu par email.',
    },
    AUTO_LOGIN_EXPIRED: {
      title: 'Erreur d\'authentification',
      text: 'Le lien que vous avez utilisé est inactif !',
    },
    AUTO_LOGIN_PROJECT_ERROR: {
      title: 'Erreur d\'authentification',
      text: 'Aucun projet de déménagement trouvé, avez-vous utilisé un lien correct ?',
    },
    AUTO_LOGIN_DEFINED_PASSWORD: {
      title: 'Connectez-vous',
      text: 'Connectez-vous avec votre mot de passe',
    },
    AUTO_LOGIN_FALSE_KEY: {
      title: 'Erreur d\'authentification',
      text: 'Le lien que vous avez utilisé ne fonctionne pas.',
    },
    RECOVER_PASSWORD: {
      title: 'Erreur d\'email',
      text: 'On dirait que vous avez entré une adresse email erronée... Essayez de nouveau !',
    },
    PASSWORD_KEY_EXPIRED: {
      title: 'Votre lien pour changer de mot de passe a expiré',
      text: 'Pour changer votre mot de passe il vous faut regénérer un mail de mot de passe oublié en cliquant sur le lien ci dessous',
    },
    UPDATE_EMAIL: {
      title: 'Erreur',
      text: 'Le mot de passe ou l\'email que vous avez envoyé ne semble pas valide',
    },
    POST_DECLARATION_VALOR_FILES_TOO_BIG: {
      title: 'Fichier(s) trop volumineux !',
      text: 'Il semblerait que les fichiers que vous avez envoyés sont trop volumineux (limite : 5 Mo)',
    },
    POST_PASSWORD: {
      title: 'Erreur lors de la mise à jour du mot de passe',
      text: 'Votre mot de passe n\'a pas été mis à jour : vérifiez votre ancien mot de passe',
    },
    POST_MEETING_404: {
      title: 'Ce créneau n\'est malheureusement plus disponible',
      text: 'Il semblerait que quelqu\'un a déjà pris ce créneau, pourriez-vous en choisir un autre ?',
    },
    PATCH_ADDRESS_404: {
      title: 'Adresse introuvable',
      text: 'Cette adresse n’est plus disponible. La liste a été actualisée.',
    },
    EMAIL_SUPPORT_FILES_TOO_BIG: {
      title: 'Fichier(s) trop volumineux !',
      text: 'Il semblerait que les fichiers que vous avez envoyés sont trop volumineux (limite : 12 Mo)',
    },
    FILE_INVALID: {
      title: 'Erreur',
      text: 'Le fichier que vous avez envoyé n\'est pas valide',
    },
    ALLOW_PDF_ONLY: {
      title: 'Erreur',
      text: 'Il semblerait que le fichier que vous avez envoyé n\'est pas un PDF',
    },
    NO_DEFAULT_CARD: {
      title: 'Erreur pendant la suppression de la CB',
      text: 'La CB que vous essayé de supprimer est enregistré comme moyen de paiement par défaut, veuillez choisir une autre par défaut',
    },
    EMAIL_INVALID: {
      title: 'Adresse email non reconnue',
      text: 'L\'adresse email que vous avez renseignée ne correspond pas à celle utilisée pour votre compte. Veuillez renseigner la bonne adresse email.',
    },
    NO_PAYMENT_TYPES: {
      title: 'Aucun moyen de paiement disponible',
      text: 'Veuillez réessayer ultérieurement ou nous contacter au 01.82.52.10.12 si le problème persiste.',
    },
  },
  success: {
    RECOVER_PASSWORD: {
      title: 'Email envoyé',
      text: 'Un email vous a été envoyé avec les instructions pour réinitialiser votre mot de passe.',
    },
    RESET_PASSWORD: {
      title: 'Mot de passe mis à jour',
      text: 'Votre mot de passe a bien été mis à jour, vous pouvez l\'utiliser pour vous connecter',
    },
    POST_CONTACT: {
      title: 'Votre demande a été envoyée',
      text: 'Nous allons vous recontacter dans les plus brefs délais',
    },
    POST_DECLARATION: {
      title: 'Déclaration sauvegardée',
      text: 'Votre déclaration de valeur a bien été enregistrée',
    },
    PATCH_DECLARATION: {
      title: 'Déclaration sauvegardée',
      text: 'Votre déclaration de valeur a bien été mise à jour',
    },
    PATCH_ADDRESS: {
      title: 'Adresse sauvegardée',
      text: 'Vos informations ont bien été enregistrées.',
    },
    POST_CONTACT_TRANSFERT_TRUE: {
      title: 'Transfert des contrats',
      text: 'Votre demande a bien été prise en compte. Vous serez contacté dans les plus brefs délais par notre service partenaire.',
      btn: 'OK',
    },
    POST_CONTACT_TRANSFERT_FALSE: {
      title: 'Transfert des contrats',
      text: 'Votre choix a bien été enregistré ! Si vous souhaitez tout de même bénéficier de notre service de transfert de contrats, rendez-vous sur la page « Avantages Nextories » !',
      btn: 'OK',
    },
    PRE_BOOK_OFFER: {
      title: 'Demande enregistrée',
      text: 'Votre demande de pré-réservation a bien été enregistrée',
      textIndividual: 'Votre pré-réservation a bien été enregistrée et est en attente de validation par le déménageur',
    },
    BOOK_OFFER: {
      title: 'Offre réservée',
      text: 'Votre offre a bien été réservée',
    },
    CHOOSE_OFFER: {
      title: 'Offre choisie',
      text: 'Votre offre a bien été choisie',
    },
    UPDATE_EMAIL: {
      title: 'Un email vous a été envoyé',
      text: 'Votre requête à bien été prise en compte, un email vous a été envoyé pour valider votre changement d\'adresse email',
    },
    POST_PASSWORD: {
      title: 'Mot de passe enregistré',
      text: 'Votre mot de passe a bien été enregistré, vous pouvez l\'utiliser pour votre prochaine connexion',
    },
    POST_MEETING: {
      title: 'Créneau réservé',
      text: 'Votre créneau a bien été réservé, votre conseiller vous contactera à l\'heure choisie',
    },
    DELETE_MEETING: {
      title: 'Rendez-vous annulé',
      text: 'Votre rendez-vous a bien été annulé.',
    },
    POST_CB_SAVE: {
      title: 'CB enregistrée',
      text: 'Votre carte bancaire a bien été enregistrée.',
    },
    UPDATE_CB_SAVE: {
      title: 'CB enregistré',
      text: 'Votre carte bancaire par défaut a bien été mise à jour.',
    },
    CONFIRM_PAYMENT_OFFER: {
      title: 'Paiement validé',
      text: 'Votre moyen de paiement a bien été validé.',
    },
    AUTHORIZE_PAYMENT_OFFER: {
      title: 'Paiement autorisé',
      text: 'Votre paiement a bien été autorisé.',
    },
    CONFIRM_WIRE_TRANSFER_SUBMITTED: {
      title: 'Merci',
      text: 'L\'information a été transmise à nos équipes, nous vérifions la bonne réception.',
    },
    DELETE_CB_SAVE: {
      title: 'CB supprimée',
      text: 'Votre carte bancaire a bien été supprimée.',
    },
  },
};
